<template>
  <v-container
    class="company-board py-0"
    fluid
    :height="isMobile ? '200' : '750'"
  >
    <div class="company-board-name" align-content="start">
      <div v-if="logo">
        <Logo :logo="logo" :name="name" class="logo-company" />
      </div>
      <div>
        <h1 class="display-60-36 black--text">{{ name }}</h1>
      </div>
    </div>

    <v-row class="company-board-details mt-0 my-sm-6" justify="center">
      <v-col
        align-self="center"
        class="company-details py-md-3 py-0"
        v-if="industry || numOfEmployees || numOfBranches"
      >
        <CompanyDetails
          :industry="industry"
          :numOfEmployees="numOfEmployees"
          :numOfBranches="numOfBranches"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Logo from '@/components/Company/Logo';
import CompanyDetails from '@/components/Company/CompanyDetails';

export default {
  components: {
    Logo,
    CompanyDetails,
  },

  props: {
    isMobile: {
      type: Boolean,
    },
    name: {
      type: String,
    },
    numOfEmployees: {
      type: String,
    },
    industry: {
      type: String,
    },
    logo: {
      type: String,
    },
    images: {
      type: Array,
    },
    numOfBranches: {
      type: Number,
    },
    screenWidth: {
      type: Number,
    },
  },
  data() {
    return {
      calculatedHeight: 750,
    };
  },
  watch: {
    screenWidth() {
      switch (true) {
        case this.screenWidth <= 600:
          this.calculatedHeight = 250;
          break;
        case this.screenWidth >= 600:
          this.calculatedHeight = 250;
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.company-board {
  position: relative;
  height: auto;
  background-image: url('~assets/img/sun-district-blue-business-tower.png');
  background-size: cover;
  background-position: top center;
}
.company-board-name {
  padding: 40px;
  text-align: center;
}
.company-board-details {
  position: relative;
  z-index: 5;
  background: #3e4a54;

  flex-direction: column-reverse;
  height: fit-content;
}

// #company-carousel .v-image__image--cover {
//   background-repeat: no-repeat;
//   background-size: contain !important;
// }
#company-carousel .company-image-slide {
  height: 100%;
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .company-board-details {
    flex-direction: column-reverse;
  }
}

@media only screen and (min-width: 960px) {
  .company-board-details {
    flex-direction: row;
  }
}

@media only screen and (max-width: 600px) {
  .company-board {
    background-image: url('~assets/img/company-header-mobile.png');
    background-size: 100% 100%;
    background-position: top center;
  }
}
</style>
